import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import { FormattedMessage } from "react-intl";

export default function FiisExternalLinks() {
  const { website, fundosNetHref, managementReport } = useBrazilianRealEstateFundIssuer();

  return (
    <div className="flex flex-col gap-2 divide-gray-200 dark:divide-gray-700 lg:flex-row lg:gap-0 lg:divide-x lg:*:px-2 lg:first:*:pl-0 lg:last:*:pr-0">
      {managementReport && managementReport.linkHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={managementReport.linkHref}
          className="text-sm font-medium text-blue-600 hover:underline dark:text-blue-400"
        >
          <span>
            <FormattedMessage defaultMessage="Relatório Gerencial" id="gPZvf6" />
          </span>
        </a>
      )}

      {website && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={website}
          className="text-sm font-medium text-blue-600 hover:underline dark:text-blue-400"
        >
          <span>
            <FormattedMessage defaultMessage="Site do Fundo" id="2euywa" />
          </span>
        </a>
      )}

      {fundosNetHref && (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={fundosNetHref}
          className="text-sm font-medium text-blue-600 hover:underline dark:text-blue-400"
        >
          <span>
            <FormattedMessage defaultMessage="Arquivos" id="7ahQI4" />
          </span>
        </a>
      )}
    </div>
  );
}
